import { Clients, useQuery } from "../apollo";
import { GetUserQuery } from "../graphql/queries/getUser";
import { GetUserRequestType, UserType } from "../types/user";
import { useGetCurrentUser } from "./useGetCurrentUser";

export type GetUserResponseType = {
  getUser: UserType;
};

export const useIAm = () => {
  const currentUser = useGetCurrentUser();

  return useQuery<GetUserResponseType, GetUserRequestType>(
    Clients.UPS,
    GetUserQuery,
    {
      variables: {
        username: currentUser?.username,
        region: currentUser?.region,
      },
      fetchPolicy: "cache-and-network",
      skip: !currentUser?.username || !currentUser?.region,
    },
  );
};
